"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _typeof2 = require("babel-runtime/helpers/typeof"),
    _typeof3 = _interopRequireDefault(_typeof2),
    _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _entries = require("babel-runtime/core-js/object/entries"),
    _entries2 = _interopRequireDefault(_entries),
    _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _Button = require("office-ui-fabric-react/lib/Button"),
    _saveFile = require("./saveFile"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _formatting = require("../../formatting");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
} // documentation for javscript-excel
// https://github.com/securedeveloper/react-data-export
// https://github.com/securedeveloper/javascript-excel
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
//     <ExcelFile element={<DefaultButton {...btnProps} />}>
//       {sheets.map((s, sidx) => (
//         <ExcelSheet key={sidx} data={s.data} name={s.name}>
//           {s.columns.map((c, cidx) => (
//             <ExcelColumn key={"c" + sidx + cidx} {...c} />
//           ))}
//         </ExcelSheet>
//       ))}
//     </ExcelFile>
//import ReactExport from "javascript-excel";


function transformCell(a) {
  return "boolean" == typeof a ? (0, _formatting.doFormatYesNo)(a) : Array.isArray(a) ? a.join(", ") : a;
}

function transform(a) {
  var b = (0, _extends3.default)({}, a);
  return (0, _entries2.default)(a).map(function (a) {
    b[a[0]] = transformCell(a[1]);
  }), b;
}

var SaveExcel = _react2.default.memo(function (a) {
  function b() {
    if (!!g) {
      var a = g.map(function (a) {
        return a[0];
      }),
          b = d.map(function (a) {
        return g.map(function (b) {
          var c = (0, _slicedToArray3.default)(b, 2),
              d = c[1],
              e = "";
          return "string" == typeof d ? e = (0, _get2.default)(a, d, "") : "function" == typeof d ? (e = d(a), !e && (e = ""), void 0) : Array.isArray(d) && (e = d.map(function (b) {
            return (0, _get2.default)(a, b, "");
          }).join(" ")), transformCell(e);
        });
      });
      b.unshift(a), (0, _saveFile.exportRowsToCsv)(b, h);
    } else !e ? (0, _saveFile.saveJsonTableAsCsv)({
      jsonTable: d,
      fileName: h
    }) : (0, _saveFile.saveJsonTableAsCsv)({
      jsonTable: d.map(transform),
      fileName: h,
      fields: e.map(function (a) {
        return "string" == typeof a ? "object" === ("undefined" == typeof f ? "undefined" : (0, _typeof3.default)(f)) ? {
          value: a,
          label: (0, _get2.default)(f, a, a)
        } : {
          value: a,
          label: a
        } : {
          value: a.name,
          label: a.label
        };
      })
    });
  }

  var c = a.btnProps,
      d = a.jsonTable,
      e = a.columns,
      f = a.columnsMap,
      g = a.colDefns,
      h = a.fileName;
  return "type" in c && "action" === c.type ? _react2.default.createElement(_Button.ActionButton, (0, _extends3.default)({}, c, {
    onClick: b
  })) : _react2.default.createElement(_Button.DefaultButton, (0, _extends3.default)({
    text: "Download"
  }, c, {
    onClick: b
  }));
});

exports.default = SaveExcel;